import { render, staticRenderFns } from "./courseDetailPage.vue?vue&type=template&id=424db19a&scoped=true"
import script from "./courseDetailPage.vue?vue&type=script&lang=js"
export * from "./courseDetailPage.vue?vue&type=script&lang=js"
import style0 from "./courseDetailPage.vue?vue&type=style&index=0&id=424db19a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424db19a",
  null
  
)

export default component.exports